import { render, staticRenderFns } from "./ImageDeck.vue?vue&type=template&id=18cf78a6&scoped=true&"
import script from "./ImageDeck.vue?vue&type=script&lang=js&"
export * from "./ImageDeck.vue?vue&type=script&lang=js&"
import style0 from "./ImageDeck.vue?vue&type=style&index=0&id=18cf78a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cf78a6",
  null
  
)

export default component.exports